<template>
  <div>
    <v-btn
      id="editor-settings-button"
      color="primary"
      elevation="0"
      text
      small
      @click="bus.$emit('show-theme-dialog')"
    >
      <v-icon left small>mdi-palette-outline</v-icon>Theme
    </v-btn>
  </div>
</template>

<script>
import projectMixin from "./project-mixin";
export default {
  mixins: [projectMixin]
};
</script>
